/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import PropTypes from 'prop-types';
import { DescriptionListProps } from './DescriptionListProps';

import './DescriptionList.scss';

const DescriptionList: FunctionComponent<DescriptionListProps> = ({ items }): JSX.Element => {
    return (
        <div className="description-list-container">
            {items
                .filter((item) => item.value)
                .map((item, index) => {
                    return (
                        <div key={index} className="details">
                            <div className="title">{item.title}:</div>
                            <div className="value">{item.value}</div>
                        </div>
                    );
                })}
        </div>
    );
};

DescriptionList.propTypes = {
    items: PropTypes.any,
};

export default DescriptionList;
